"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraRequestDeniedOrAborted = exports.CameraRequestPending = exports.CameraRequestPrompt = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const video_frame_1 = require("../video_frame");
// Given a *current* camera subject, return the best text description to use
// for the camera subject they're *going to flip to*.
const flipToCameraText = (cameraSubject) => {
    switch (cameraSubject) {
        case streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON:
            return 'rear-facing';
        case streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD:
        default:
            return 'front-facing';
    }
};
const CameraRequestPrompt = ({ cameraSubject }) => {
    return ((0, jsx_runtime_1.jsxs)(LargeWrapper, Object.assign({ "data-testid": "camera-request-prompt" }, { children: [(0, jsx_runtime_1.jsx)(RequestHeader, Object.assign({ as: "p", color: "dark", size: "medium", bold: true, headingFontFamily: true }, { children: "Request to Flip Camera" })), (0, jsx_runtime_1.jsxs)(ui_react_1.AppText, Object.assign({ as: "p", color: "dark", size: "small" }, { children: ["This will ask the customer to start the ", flipToCameraText(cameraSubject), " view."] }))] })));
};
exports.CameraRequestPrompt = CameraRequestPrompt;
const CameraRequestPending = () => {
    return ((0, jsx_runtime_1.jsx)(RequestPending, Object.assign({ color: "dark", size: "small", as: "p" }, { children: "Requested to Flip Camera" })));
};
exports.CameraRequestPending = CameraRequestPending;
const CameraRequestDeniedOrAborted = ({ requestState, onRequest, onCancel, }) => {
    const isDenied = requestState === video_frame_1.CameraRequestState.REQUEST_DENIED;
    return ((0, jsx_runtime_1.jsxs)(LargeWrapper, Object.assign({ "data-testid": `camera-request-${isDenied ? 'denied' : 'aborted'}-prompt` }, { children: [(0, jsx_runtime_1.jsx)(DeniedHeader, Object.assign({ as: "p", color: "dark", size: "medium", bold: true, headingFontFamily: true }, { children: isDenied ? 'Camera Flip Denied' : 'Camera Flip Error' })), (0, jsx_runtime_1.jsx)(DeniedBody, Object.assign({ as: "p", color: "dark", size: "small" }, { children: isDenied
                    ? 'Your request to flip camera was denied.'
                    : 'There was an error attempting to flip the camera. Please try again.' })), (0, jsx_runtime_1.jsxs)(TooltipButtonRow, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ variant: "tertiary", onClick: onCancel, fontSize: "small" }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ variant: "tertiary", onClick: onRequest, fontSize: "small", "data-testid": `camera-request-${isDenied ? 'denied' : 'aborted'}-request-again-button` }, { children: "Request Again" }))] })] })));
};
exports.CameraRequestDeniedOrAborted = CameraRequestDeniedOrAborted;
const DeniedHeader = (0, ui_react_1.styled)(ui_react_1.AppText) `
    padding-bottom: 2px;
`;
const DeniedBody = (0, ui_react_1.styled)(ui_react_1.AppText) `
    padding-bottom: 6px;
`;
const RequestHeader = (0, ui_react_1.styled)(ui_react_1.AppText) `
    padding-bottom: 4px;
`;
const RequestPending = (0, ui_react_1.styled)(ui_react_1.AppText) `
    width: 150px;
    padding: 6px;
`;
const TooltipButtonRow = (0, ui_react_1.styled)(ui_react_1.ButtonRow)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.25rem',
    '>*:not(:last-of-type)': {
        marginRight: 0,
    },
});
const LargeWrapper = ui_react_1.styled.div `
    width: 210px;
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 7px;
    padding-top: 4px;
`;
//# sourceMappingURL=camera_request_messages.js.map